import { __rest } from "tslib";
import React from 'react';
import { PnmacPaper, PnmacHtmlToNative } from 'pnmac-universal-components';
export var ErrorMessage = function (_a) {
  var props = __rest(_a, []);
  return /*#__PURE__*/React.createElement(PnmacPaper, {
    onPress: function () {
      return props.onClick();
    },
    containerStyles: {
      padding: 25,
      marginBottom: 10,
      borderRadius: 10,
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      boxShadow: "rgba(0, 0, 0, 0.08) 2px 4px 12px",
      color: "#881701",
      backgroundColor: "#F2BBB8",
      elevation: 1,
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
    value: props.message
  }));
};